const BaseError = require('make-error').BaseError;

class DuplicateError extends BaseError {
    constructor(errorMessage = 'A record matching this criteria already exists', details = {}) {
        super(errorMessage);
        for (const key of ['code', 'keyPattern', 'keyValue']) {
            if (details[key] !== undefined) this[key] = details[key];
        }
        this.index =
            typeof details.index === 'string'
                ? details.index
                : details.message?.match(/index: ([^ ]+)/)?.[1];
    }
}

module.exports = DuplicateError;